/**
 * Created by johannes on 15/05/2017.
 */
import * as Phaser from "phaser";
import {PlayState} from "./playstate";

import {LevelLoader} from "./levelloader";
import {Player} from "./player";
import Tilemap = Phaser.Tilemap;
import Point = Phaser.Point;
import game = PIXI.game;
import Key = Phaser.Key;


var mainMenuButton;
var levelComplete;
var nextLevelButton;
export class LevelCompleteState extends Phaser.State {
    levelList = new Array();
    currentLevel: number;

    init(level: number) {
        this.stage.backgroundColor = '#FFF';
        this.currentLevel = level;
        //console.log("currentlevel: " + this.currentLevel);
    }

    preload() {
    }

    create() {
        levelComplete = this.game.add.sprite(this.game.width/2 -160,200, 'levelCompleteMessage');
        //levelComplete.scale.setTo(0.25);

        mainMenuButton = this.game.add.button(this.game.width/2 -100, 300, 'menuButton',this.loadMenu, this, 2, 1,0);

        nextLevelButton = this.game.add.button(this.game.width/2 +20, 300, 'nextLevelButton',this.nextLevel, this, 2, 1,0);
    }

    nextLevel(){
        this.game.world.removeAll();
        PIXI.game.state.start('PlayState', true, false, this.currentLevel + 1);
    }

    loadMenu(){
        this.game.world.removeAll();
        this.game.state.start('MenuState', true, false);
    }
}






// WEBPACK FOOTER //
// ./src/levelcompletestate.ts